module.exports = __webpack_public_path__ + "static/media/fraternity.61e6dd52.png";